import PannelBody from "../../../fragments/PannelBody"
import { noteTypesOptions } from "../../../../lib/systemData"
import classes from './AddNotes.module.css'
import React from "react"

export const LinkToNotesTypes = ({currentWorkQ, setNoteTypeHandler, noteTypes}) => {
    const linkedNoteTypes = noteTypes ?? currentWorkQ?.note_types ?? []

    if (!linkedNoteTypes.length) {
        return null
    }

    return <PannelBody padding='large'>
        <p>Current WorkQ is associated with the following note types: {linkedNoteTypes.map(item => {
            return (
                <React.Fragment key={item}>
                    <button
                        onClick={setNoteTypeHandler.bind(null, item)}
                        className={classes.button_link}
                    >
                        {noteTypesOptions().find(option => option.value == item)?.name}
                    </button>
                    {linkedNoteTypes.indexOf(item) !== linkedNoteTypes.length - 1 && ', '}
                </React.Fragment>
            )
        })}</p>
    </PannelBody>
}
